module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', [_c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo de documento"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.document) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                  ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo de documento",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.document) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "emisionDate",
      "label": "Fecha de emisión",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "resize": "none",
            "rows": 3
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Documentación",
      "visible": _vm.showModalDocumentation,
      "width": "70%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentation = $event
      },
      "close": function($event) {
        _vm.showModalDocumentation = false
      }
    }
  }, [(!_vm.user.isProvider) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Compañia")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleccione Compania"
    },
    model: {
      value: (_vm.idCompany),
      callback: function($$v) {
        _vm.idCompany = $$v
      },
      expression: "idCompany"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.companyName,
        "value": item.idCompany
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Fecha de emisión")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy/MM/dd",
      "placeholder": "Fecha de emisión"
    },
    model: {
      value: (_vm.emisionDate),
      callback: function($$v) {
        _vm.emisionDate = $$v
      },
      expression: "emisionDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Tipo de documento")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de documento"
    },
    model: {
      value: (_vm.idDocument),
      callback: function($$v) {
        _vm.idDocument = $$v
      },
      expression: "idDocument"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.idDocument,
      attrs: {
        "label": item.documentName,
        "value": item.idDocument
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    ref: "fileDocument",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModalDocumentation = false, _vm.resetModal()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadDocumentation()
      }
    }
  }, [_vm._v("\n            Enviar\n          ")])])])], 1), _vm._v(" "), (_vm.providerDocumentStatus) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item, index) {
    return _c('th', {
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.providerDocumentStatus.length) + '%')
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item, index) {
    return _c('td', {
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.idProviderDocumentStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.getCountByStatus(item.idProviderDocumentStatus)))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#bf0532",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.showModalDocumentation = true
      }
    }
  }, [_vm._v("\n                Subir Documentación\n            ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Estado"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item) {
    return _c('el-option', {
      key: item.idProviderDocumentStatus,
      attrs: {
        "value": item.idProviderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.documents,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [(!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Compañia",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.companyName) + "\n          ")]
      }
    }], null, false, 1737064925)
  }) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "CUIT",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.cuit) + "\n          ")]
      }
    }], null, false, 2208011766)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Fecha de alta",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.date) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Fecha de emisión",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.emisionDate) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.status) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo de documento",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.document) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Justificacion Rechazo",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.mensajeRechazo)
            }
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.mensajeRechazo) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Documento",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "circle": "",
            "type": "primary",
            "icon": "el-icon-document"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.user.isProvider && _vm.documents.some(function (el) { return el.status === 'Enviado'; })) ? _c('el-table-column', {
    attrs: {
      "label": "Aceptar",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "disabled": _vm.documentosAceptados.length === 0 && _vm.documentosRechazados.length === 0,
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.abrirModalConfirmacion()
            }
          }
        }, [_vm._v("\n              Aceptar\n            ")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 'Enviado') ? [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": (_vm.documentosAceptados.includes(scope.row)) ? 'success' : ''
          },
          on: {
            "click": function($event) {
              return _vm.handleIncluirDocumento(scope.row, 1)
            }
          }
        }, [_vm._v("\n                Si\n              ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": (_vm.documentosRechazados.includes(scope.row)) ? 'danger' : ''
          },
          on: {
            "click": function($event) {
              return _vm.handleIncluirDocumento(scope.row, 2)
            }
          }
        }, [_vm._v("\n                No\n              ")])], 1)] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8841e0dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SubmitDocumentation.vue
// module id = 646
// module chunks = 1